import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _PropTypes from 'prop-types';
import { Breadcrumb } from '../Breadcrumb/Breadcrumb.js';
import { BreadcrumbItem } from '../BreadcrumbItem/BreadcrumbItem.js';
import { jsx } from 'react/jsx-runtime';

function Breadcrumbs(_ref) {
  var breadcrumbs = _ref.breadcrumbs;
  return /*#__PURE__*/jsx(Breadcrumb, {
    children: breadcrumbs.map(function (breadcrumbProps, i) {
      return /*#__PURE__*/jsx(BreadcrumbItem, _objectSpread({
        label: breadcrumbProps.label
      }, breadcrumbProps), i);
    })
  });
}

Breadcrumbs.propTypes = {
  "breadcrumbs": _PropTypes.arrayOf(_PropTypes.object).isRequired
};
Breadcrumbs.displayName = "Breadcrumbs";

export { Breadcrumbs };
